import React from 'react'
import { Box, Grid, Heading } from '@chakra-ui/react'
import { StockData } from '../types'
import { formatCurrency, formatNumber, formatPrice } from '../utils'
import StatCard from './StatCard'

interface MarketDataPanelProps {
  data: StockData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const MarketDataPanel: React.FC<MarketDataPanelProps> = ({
  data,
  gridTemplateColumns,
  statCardBg
}) => {
  return (
    <Box>
      <Heading as="h3" mb={4} size="md">Market Data</Heading>
      <Grid gap={4} templateColumns={`repeat(${gridTemplateColumns || 2}, 1fr)`}>
        <StatCard
          bg={statCardBg}
          label="Market Cap"
          value={formatCurrency(data.marketCap)}
        />
        <StatCard
          bg={statCardBg}
          label="Volume"
          value={formatNumber(data.volume)}
        />
        <StatCard
          bg={statCardBg}
          label="Avg Volume"
          value={formatNumber(data.avgVolume)}
        />
        <StatCard
          bg={statCardBg}
          label="Open"
          value={formatPrice(data.open)}
        />
        <StatCard
          bg={statCardBg}
          label="Previous Close"
          value={formatPrice(data.previousClose)}
        />
        <StatCard
          bg={statCardBg}
          label="Day High"
          value={formatPrice(data.dayHigh)}
        />
        <StatCard
          bg={statCardBg}
          label="Day Low"
          value={formatPrice(data.dayLow)}
        />
        <StatCard
          bg={statCardBg}
          label="52 Week High"
          value={formatPrice(data.week52High)}
        />
        <StatCard
          bg={statCardBg}
          label="52 Week Low"
          value={formatPrice(data.week52Low)}
        />
        <StatCard
          bg={statCardBg}
          label="Beta"
          value={data.beta.toFixed(2)}
        />
      </Grid>
    </Box>
  )
}

export default MarketDataPanel
